import { SVGProps } from 'react';

const CheckBoxIcon = (svg: SVGProps<SVGSVGElement>) => (
  <svg {...svg} width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.83268 2.5L4.24935 7.08333L2.16602 5" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CheckBoxIcon;
